export var WidgetType;
(function (WidgetType) {
    WidgetType["WIDGET_TYPE_STAT"] = "WIDGET_TYPE_STAT";
    WidgetType["WIDGET_TYPE_TIMESERIES"] = "WIDGET_TYPE_TIMESERIES";
    WidgetType["WIDGET_TYPE_TABLE"] = "WIDGET_TYPE_TABLE";
    WidgetType["WIDGET_TYPE_STATE_LIST"] = "WIDGET_TYPE_STATE_LIST";
})(WidgetType || (WidgetType = {}));
